// Ported from relay-protocol packages/relay-widget (v0.1.0).
// Self-implemented viem-equivalent numeric utils: dapp-ui forbids viem.
// All wei-scale math stays in BigInt end-to-end; formatUnits is a pure
// digit-shift (floor semantics, no rounding); parseUnits THROWS on
// over-precision input (callers treat a throw as "invalid amount").

export const zeroAddress = "0x0000000000000000000000000000000000000000" as const;

const ADDRESS_RE = /^0x[0-9a-fA-F]{40}$/;

export function isAddress(value: string): boolean {
  return ADDRESS_RE.test(value);
}

export function formatUnits(value: bigint, decimals: number): string {
  const negative = value < 0n;
  const abs = negative ? -value : value;
  const s = abs.toString().padStart(decimals + 1, "0");
  const intPart = decimals === 0 ? s : s.slice(0, -decimals);
  const fracPart = decimals === 0 ? "" : s.slice(-decimals).replace(/0+$/, "");
  const body = fracPart ? `${intPart}.${fracPart}` : intPart;
  return negative ? `-${body}` : body;
}

export function parseUnits(value: string, decimals: number): bigint {
  const m = value.match(/^(-?)(\d+)(?:\.(\d+))?$/);
  if (!m) throw new Error(`parseUnits: invalid decimal string "${value}"`);
  const [, sign, intPart, fracPart = ""] = m;
  if (fracPart.length > decimals) {
    throw new Error(`parseUnits: too many decimal places for ${decimals} decimals`);
  }
  const combined = BigInt(intPart + fracPart.padEnd(decimals, "0"));
  return sign === "-" ? -combined : combined;
}
